import React, { useCallback, useEffect, useState } from "react";
import styles from "./index.module.less";
import { Loading3QuartersOutlined } from "@/utils/antdIcon";
import { Spin } from "antd";
import { useTimeoutFn } from "@/utils/chat/index";

interface IProps {
  text?: string;
  delay?: number;
  onTimeout?: Function;
}
function AiLoading(props: IProps) {
  const antIcon = <Loading3QuartersOutlined style={{ fontSize: 14 }} spin />;
  const { text = "已完成语意理解，正在思考分析...", onTimeout, delay = 30 * 1000} = props;
  const [loadingDelay, setLoadingDelay] = useState(delay);

  const handleTimeout = useCallback(() => {
    onTimeout?.();
  }, [onTimeout]);

  useTimeoutFn(handleTimeout, loadingDelay);

  return (
    <div className={styles["ai-loading-wrap"]}>
      <Spin
        spinning={true}
        size="small"
        delay={5}
        indicator={antIcon}
        style={{
          width: "14px",
          height: "14px",
          lineHeight: "14px"
        }}
      />
      <span className={styles["text"]}>{text}</span>
    </div>
  );
}

export default AiLoading;
